export default "__VITE_ASSET__DVimdu0L__"